import { Link } from 'react-router-dom';
import './Programs.css';

const programs = [
  {
    id: 'humanitarian',
    icon: '❤',
    title: 'Humanitarian Work',
    img: '/img/humanitarian.JPG',
    color: '#e63946',
    details: [
      'As I travel around the world I have seen too many suffering — too many hurting and hungry people, especially the children. Too many people in poverty.',
      'Matthew 25:35-40 is the heartbeat of Christ and the foundation of our humanitarian ministry: "For I was hungry and you gave me food, I was thirsty and you gave me drink, I was a stranger and you welcomed me."',
      'New Birth CCCI partners with local churches in India, Africa, and around the world to provide food, clothing, medical assistance, and practical care to those most in need.',
    ],
    highlights: ['Food & Water Relief', 'Medical Assistance', 'Children\'s Care', 'Poverty Support', 'Community Development', 'Disaster Response'],
  },
  {
    id: 'equipping',
    icon: '📖',
    title: 'Equipping Ministers',
    img: '/img/trainingministers.JPG',
    color: '#2d6a4f',
    details: [
      'We believe in equipping ministers with biblical and academic knowledge to enable them to represent Christ substantially and excel in their various ministries and calling on earth.',
      'Many pastors — particularly in India and Africa — serve faithfully without proper licensing or formal theological training. New Birth CCCI bridges that gap by providing licensing, mentorship, and educational resources.',
      'Our equipping programs include ordination services, ministry workshops, leadership training, and ongoing pastoral support to help ministers grow in their calling.',
    ],
    highlights: ['Pastoral Licensing', 'Ordination Services', 'Ministry Workshops', 'Leadership Training', 'Biblical Education', 'Pastoral Counselling'],
  },
  {
    id: 'soulwinning',
    icon: '✝',
    title: 'Soul Winning Outreaches',
    img: '/img/outreach.JPG',
    color: '#1d3557',
    details: [
      'Soul winning is our priority. "What shall it profit a man to gain the whole world and lose his soul?" — Mark 8:36.',
      'We are committed to winning souls for Jesus. We do this by taking the gospel to the poor and the rich through evangelism and programs, reaching communities that have never heard the message of salvation.',
      'Our outreach teams travel locally and internationally, conducting open-air crusades, community evangelism, church planting, and follow-up discipleship to ensure lasting fruit.',
    ],
    highlights: ['Open-Air Crusades', 'Community Evangelism', 'Church Planting', 'Discipleship Programs', 'Gospel Literature', 'International Missions'],
  },
];

export default function Programs() {
  return (
    <>
      <div className="page-banner">
        <h1>Our Programs</h1>
        <p>Activities that define our mission worldwide</p>
        <nav className="breadcrumb">
          <Link to="/">Home</Link>
          <span>/</span>
          <span>Programs</span>
        </nav>
      </div>

      <section className="programs-intro">
        <div className="container" style={{ textAlign: 'center', maxWidth: '700px' }}>
          <p className="section-label">What We Do</p>
          <h2 className="section-title">Driven by Faith, <span>Powered by Love</span></h2>
          <p style={{ color: '#666', lineHeight: '1.8', fontSize: '0.95rem' }}>
            Everything New Birth CCCI does flows from a singular passion — advancing the Kingdom of
            God by winning souls, caring for the vulnerable, and raising up strong ministers to serve
            the body of Christ.
          </p>
        </div>
      </section>

      {programs.map(({ id, icon, title, img, details, highlights }, i) => (
        <section key={id} className={`program-detail ${i % 2 === 1 ? 'reverse' : ''}`}>
          <div className="container pd-grid">
            <div className="pd-img-col">
              <img src={img} alt={title} />
            </div>
            <div className="pd-text-col">
              <div className="pd-icon">{icon}</div>
              <p className="section-label">Program {i + 1}</p>
              <h2 className="section-title">{title}</h2>
              {details.map((d, j) => (
                <p key={j} style={{ color: '#555', lineHeight: '1.8', fontSize: '0.95rem', marginBottom: '0.9rem' }}>{d}</p>
              ))}
              <div className="highlights-grid">
                {highlights.map(h => (
                  <div key={h} className="highlight-item">
                    <span className="hl-check">✓</span>
                    <span>{h}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      ))}

      <section className="programs-cta" style={{ backgroundImage: 'url(/img/missioninindia.jpg)' }}>
        <div className="programs-cta-overlay" />
        <div className="container" style={{ position: 'relative', zIndex: 1, textAlign: 'center' }}>
          <p className="section-label" style={{ color: 'var(--gold-light)' }}>Get Involved</p>
          <h2 style={{ color: '#fff', fontSize: '2.5rem', marginBottom: '1rem' }}>Support Our Mission</h2>
          <p style={{ color: 'rgba(255,255,255,0.85)', maxWidth: '560px', margin: '0 auto 2rem', lineHeight: '1.8' }}>
            Your support — whether through prayer, volunteering, or financial giving — makes it
            possible to reach more souls, feed more hungry children, and equip more ministers for
            Christ.
          </p>
          <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <a href="https://www.paypal.com/donate" className="btn-primary-gold" target="_blank" rel="noreferrer">
              Donate Now
            </a>
            <Link to="/contact" className="btn-outline-white">Contact Us</Link>
          </div>
        </div>
      </section>
    </>
  );
}
